export const L10nObj = {
  'es-ES': {
    grid: {
      EmptyRecord: 'No hay datos que mostrar',
      StartsWith: 'Empieza por',
      EndsWith: 'Termina por',
      Contains: 'Contiene',
      Equal: 'Es igual a',
      NotEqual: 'No es igual a',
      GreaterThan: 'Mayor que',
      GreaterThanOrEqual: 'Mayor o igual que',
      LessThan: 'Menor que',
      LessThanOrEqual: 'Menor o igual que',
      Search: 'Buscar',
      Pdfexport: 'Exportar a PDF',
      Excelexport: 'Exportar a EXCEL',
      Print: 'Imprimir',
      FilterButton: 'Filtrar',
      ClearButton: 'Borrar',
      EnterValue: 'Introduzca el valor',
      ChooseDate: 'Introduzca la fecha',
      SelectAll: 'Seleccionar todo',
    },
    pager: {
      pagerDropDown: 'Registros por página',
      pagerAllDropDown: 'Registros',
      totalItemsInfo: '({0} registros)',
      currentPageInfo: 'Página {0} de {1}',
      All: 'Todo',
      firstPageTooltip: 'Ir a la primera página',
      lastPageTooltip: 'Ir a la última página',
      nextPageTooltip: 'Ir a siguiente página',
      previousPageTooltip: 'Ir a página previa',
    },
    dropdowns: {
      noRecordsTemplate: 'No encontrado',
    },
    datepicker: {
      today: 'Hoy',
    },
  },
  es: {
    grid: {
      EmptyRecord: 'No hay datos que mostrar',
      StartsWith: 'Empieza por',
      EndsWith: 'Termina por',
      Contains: 'Contiene',
      Equal: 'Es igual a',
      NotEqual: 'No es igual a',
      GreaterThan: 'Mayor que',
      GreaterThanOrEqual: 'Mayor o igual que',
      LessThan: 'Menor que',
      LessThanOrEqual: 'Menor o igual que',
      Search: 'Buscar',
      Pdfexport: 'Exportar a PDF',
      Excelexport: 'Exportar a EXCEL',
      Print: 'Imprimir',
      FilterButton: 'Filtrar',
      ClearButton: 'Borrar',
      EnterValue: 'Introduzca el valor',
      ChooseDate: 'Introduzca la fecha',
      SelectAll: 'Seleccionar todo',
    },
    pager: {
      pagerDropDown: 'Registros por página',
      pagerAllDropDown: 'Registros',
      totalItemsInfo: '({0} ítems)',
      currentPageInfo: 'Página {0} de {1}',
      All: 'Todo',
      firstPageTooltip: 'Ir a la primera página',
      lastPageTooltip: 'Ir a la última página',
      nextPageTooltip: 'Ir a siguiente página',
      previousPageTooltip: 'Ir a página previa',
    },
    dropdowns: {
      noRecordsTemplate: 'No encontrado',
    },
    datepicker: {
      today: 'Hoy',
    },
  },
  en: {
    grid: {
      EmptyRecord: 'No records to show',
      StartsWith: 'Starts with',
      EndsWith: 'Ends with',
      Contains: 'Contains',
      Equal: 'Equal to',
      NotEqual: 'Not equal to',
      GreaterThan: 'Greater than',
      GreaterThanOrEqual: 'Greater than or equal to',
      LessThan: 'Less than',
      LessThanOrEqual: 'Less than or equal to',
      Search: 'Search',
      Pdfexport: 'PDF',
      Excelexport: 'EXCEL',
      Print: 'Print',
      EnterValue: 'Enter the value',
      FilterButton: 'Filter',
      ClearButton: 'Clear',
      SelectAll: 'Select all',
    },
    pager: {
      pagerDropDown: 'Items per page',
      pagerAllDropDown: 'Items',
      totalItemsInfo: '({0} total items)',
      currentPageInfo: 'Page {0} out of {1}',
      All: 'All',
      firstPageTooltip: 'Go to first page',
      lastPageTooltip: 'Go to last page',
      nextPageTooltip: 'Go to next page',
      previousPageTooltip: 'Go to previous page',
    },
    dropdowns: {
      noRecordsTemplate: 'No records found',
    },
    datepicker: {
      today: 'Today',
    },
  },
  ca: {
    grid: {
      EmptyRecord: 'No hi ha dades per mostrar',
      StartsWith: 'Comença per',
      EndsWith: 'Acaba amb',
      Contains: 'Conté',
      Equal: 'És igual a',
      NotEqual: 'No és igual a',
      GreaterThan: 'Més gran que',
      GreaterThanOrEqual: 'Més gran o igual que',
      LessThan: 'Menys que',
      LessThanOrEqual: 'Menys o igual que',
      Search: 'Cerca',
      Pdfexport: 'Exportar a PDF',
      Excelexport: 'Exportar a EXCEL',
      Print: 'Imprimir',
      FilterButton: 'Filtrar',
      ClearButton: 'Netejar',
      EnterValue: 'Introduïu el valor',
      ChooseDate: 'Introduïu la data',
      SelectAll: 'Seleccionar tot',
    },
    pager: {
      pagerDropDown: 'Elements per pàgina',
      pagerAllDropDown: 'Elements',
      totalItemsInfo: '({0} elements totals)',
      currentPageInfo: 'Pàgina {0} de {1}',
      All: 'Tot',
      firstPageTooltip: 'Anar a la primera pàgina',
      lastPageTooltip: 'Anar a l’última pàgina',
      nextPageTooltip: 'Anar a la pàgina següent',
      previousPageTooltip: 'Anar a la pàgina anterior',
    },
    dropdowns: {
      noRecordsTemplate: 'No trobat',
    },
    datepicker: {
      today: 'Avui',
    },
  },
  eu: {
    grid: {
      EmptyRecord: 'Ez dago erakusteko daturik',
      StartsWith: 'Hasi',
      EndsWith: 'Amaitu',
      Contains: 'Barne',
      Equal: 'Berbera da',
      NotEqual: 'Ez da berbera',
      GreaterThan: 'Handiagoa da',
      GreaterThanOrEqual: 'Handiagoa edo berdina da',
      LessThan: 'Txikiagoa da',
      LessThanOrEqual: 'Txikiagoa edo berdina da',
      Search: 'Bilatu',
      Pdfexport: 'PDF',
      Excelexport: 'EXCEL',
      Print: 'Inprimatu',
      FilterButton: 'Iragazi',
      ClearButton: 'Garbitu',
      EnterValue: 'Sartu balioa',
      ChooseDate: 'Sartu data',
      SelectAll: 'Hautatu dena',
    },
    pager: {
      pagerDropDown: 'Elementuak orriko',
      pagerAllDropDown: 'Elementuak',
      totalItemsInfo: '({0} elementu guztiak)',
      currentPageInfo: '{0} orria {1}-etik',
      All: 'Denak',
      firstPageTooltip: 'Joan lehen orrira',
      lastPageTooltip: 'Joan azken orrira',
      nextPageTooltip: 'Joan hurrengo orrira',
      previousPageTooltip: 'Joan aurreko orrira',
    },
    dropdowns: {
      noRecordsTemplate: 'Ez da aurkitu',
    },
    datepicker: {
      today: 'Gaur',
    },
  },
};
